import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuickSearchWidget = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedType, setSelectedType] = useState('');

  const trailerTypes = [
    { value: 'utility', label: 'Utility', icon: 'Package' },
    { value: 'enclosed', label: 'Enclosed', icon: 'Box' },
    { value: 'flatbed', label: 'Flatbed', icon: 'Truck' },
    { value: 'car-hauler', label: 'Car Hauler', icon: 'Car' }
  ];

  const handleSearch = () => {
    navigate('/search-results', { state: { query: searchQuery, type: selectedType } });
  };

  const handleQuickType = (type) => {
    setSelectedType(type);
    navigate('/search-results', { state: { type } });
  };

  return (
    <div className="bg-gradient-to-br from-primary to-primary/80 rounded-lg shadow-elevation-3 p-6">
      <div className="flex items-center space-x-2 mb-4">
        <Icon name="Search" size={24} strokeWidth={2} className="text-primary-foreground" />
        <h2 className="font-heading text-2xl font-semibold text-primary-foreground">
          Quick Search
        </h2>
      </div>
      <div className="bg-card rounded-lg p-4 mb-4">
        <div className="flex flex-col md:flex-row gap-3">
          <div className="flex-1">
            <div className="relative">
              <Icon
                name="Search"
                size={20}
                strokeWidth={2}
                className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground"
              />
              <input
                type="text"
                placeholder="Search by location, type, or features..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e?.target?.value)}
                onKeyPress={(e) => e?.key === 'Enter' && handleSearch()}
                className="w-full pl-10 pr-4 py-3 border border-border rounded-md focus:outline-none focus:ring-2 focus:ring-primary font-body"
              />
            </div>
          </div>
          <Button
            variant="default"
            size="lg"
            iconName="Search"
            onClick={handleSearch}
            className="md:w-auto"
          >
            Search
          </Button>
        </div>
      </div>
      <div>
        <p className="font-body text-sm text-primary-foreground/80 mb-3">Quick browse by type:</p>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
          {trailerTypes?.map((type) => (
            <button
              key={type?.value}
              onClick={() => handleQuickType(type?.value)}
              className="bg-card hover:bg-muted rounded-md p-3 flex flex-col items-center space-y-2 transition-smooth focus:outline-none focus:ring-2 focus:ring-primary"
            >
              <Icon name={type?.icon} size={24} strokeWidth={2} className="text-primary" />
              <span className="font-body text-sm font-medium text-foreground">{type?.label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default QuickSearchWidget;